import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import { UFCLogo } from 'src/assets/images'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './PostGraduateInauguralClassContent.styles'

const PostGraduateInauguralClassContent = () => {
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const { t } = useTranslation()
  return (
    <Box className={globalClasses.containerPages}>
      <Box className={globalClasses.topPageBreadcrumbsSearch}>
        <BreadcrumbsComponent
          crumbs={[
            {
              label: 'Home',
              path: '/news/home'
            },
            {
              label: 'Pós-Graduação',
              path: '/postgraduate'
            },
            {
              label: 'Aula Magna'
            }
          ]}
        />
      </Box>
      <Box className={classes.contentWrapper}>
        <Box className={classes.header}>
          <Typography
            component="h1"
            variant="h2"
            id="title-anchor"
            style={{ fontWeight: 700, marginBottom: 24, color: '#1A1A1A' }}
          >
            {t('news.postgraduate.inaugural-class')}
          </Typography>
          <img
            src={UFCLogo}
            alt="UFC"
            className={classes.ufcImage}
          />
        </Box>
        <Box className={classes.contentContainer}>
          <Typography
            component="p"
            className={classes.paragraph}
          >
            O Reitor da Universidade Federal do Ceará, Professor José Cândido
            Lustosa Bittencourt de Albuquerque, a Diretoria do Centro de
            Ciências, Professora Regina Célia Monteiro de Paula, e o
            Coordenador do Curso de Residência em Segurança Cibernética,
            Professor Javam de Castro Machado, convidam os alunos selecionados
            para a{' '}
            <strong>
              Aula Inaugural do Curso de Residência em Segurança Cibernética
            </strong>
            .
          </Typography>
          <Typography
            component="p"
            className={classes.locationParagraph}
          >
            Local: Auditório do Departamento de Computação - Campus do Pici -
            Centro de Ciências - Bloco 910
            <br />
            Data: 10 de maio de 2022
            <br />
            Horário: 14 horas
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default PostGraduateInauguralClassContent
